import { apiSlice } from '../../api';
import type {
  CreateApplicationDTO,
  CreateApplicationResult,
  DeleteApplicationDTO,
  DeleteApplicationResult,
  GetApplicationDTO,
  GetApplicationResult,
  GetApplicationsDTO,
  GetApplicationsResult,
  UpdateApplicationDTO,
  UpdateApplicationResult,
} from './types';

export const adminApplicationsEndpoints = apiSlice.injectEndpoints({
  endpoints: (build) => {
    return {
      getApplications: build.query<GetApplicationsResult, GetApplicationsDTO>({
        query: () => ({
          url: '/admin/v1/applications',
          method: 'GET',
        }),
        providesTags: ['Applications'],
      }),

      getApplication: build.query<GetApplicationResult, GetApplicationDTO>({
        query: ({ application_uid }) => ({
          url: `/admin/v1/applications/${application_uid}`,
          method: 'GET',
        }),
      }),

      createApplication: build.mutation<CreateApplicationResult, CreateApplicationDTO>({
        query: ({ body }) => ({
          url: '/admin/v1/applications',
          method: 'POST',
          body,
        }),
        invalidatesTags: ['Applications'],
      }),

      updateApplication: build.mutation<UpdateApplicationResult, UpdateApplicationDTO>({
        query: ({ application_uid, body }) => ({
          url: `/admin/v1/applications/${application_uid}`,
          method: 'PUT',
          body,
        }),
        invalidatesTags: ['Applications'],
      }),

      deleteApplication: build.mutation<DeleteApplicationResult, DeleteApplicationDTO>({
        query: ({ application_uid }) => ({
          url: `/admin/v1/applications/${application_uid}`,
          method: 'DELETE',
        }),
        invalidatesTags: ['Applications'],
      }),
    };
  },
});

export const { useGetApplicationsQuery } = adminApplicationsEndpoints;
export const { useGetApplicationQuery } = adminApplicationsEndpoints;
export const { useCreateApplicationMutation } = adminApplicationsEndpoints;
export const { useUpdateApplicationMutation } = adminApplicationsEndpoints;
export const { useDeleteApplicationMutation } = adminApplicationsEndpoints;

export type AdminApplicationsController = typeof adminApplicationsEndpoints;
